import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import StepId from "./StepId";
import StepPassword from "./StepPassword";
import StepNickname from "./StepNickname";
import StepReferral from "./StepReferral";
import StepComplete from "./StepComplete";
import {
  authFindByNickname,
  authSignUp,
  authVerifiedNickname,
  authVerifiedTextId,
} from "../../../api/auth";
import { enqueueSnackbar } from "notistack";
import CertAskSheet from "./CertAskSheet";
import { USER_NOT_FOUND } from "../../../api/code";
import TermsSheet from "./TermsSheet";
import { certification } from "../../../utils/iamport";
import useScreenOrientation from "../../../hooks/useScreenOrientation";
import { useHistory } from "react-router-dom";
import { LoginRouterState } from "../Login";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loadingState } from "../../../recoil/app";
import { referralLogRegister } from "../../../api/referral";
import useDialog from "../../../hooks/useDialog";
import Adjust from "@adjustcom/adjust-web-sdk";
import useNativeApp, { isApp } from "../../../hooks/useNativeApp";
import StepAddress from "./StepAddress";
import StepCertName from "./StepCertName";
import StepCertBirth from "./StepCertBirth";
import StepCertPhone from "./stepCertPhone";
import { insetState } from "../../../recoil/inset";
import OpenApp from "../../../components/openApp";
import StepCertUsedPub from "./StepCertUsedPub";
import StepCertExperience from "./StepCertExperience";
import StepCertRoute from "./StepCertRoute";

const SignupWrapper = styled.div<{ isApp: number | null }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 500px;
  height: 100%;
  min-height: 1000px;
  max-height: 
  z-index: 10;
  background: white;
  transition: all 0.5s ease-in-out;

  div.wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .route-section {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    transition: all 0.3s ease-in-out;
  }

  .route-section.transition-wrap-enter-done {
    position: relative;
  }

  .transition-wrap {
    position: absolute;
    left: 15px;
    right: 15px;
    transition: all 0.3s ease-in-out;
  }

  .transition-group.left .transition-wrap-enter {
    position: absolute;
    opacity: 0;
    transform: translate3d(20px, 0, 0);
  }

  .left .transition-wrap-enter-active {
    opacity: 1;
    transform: translate3d(100%, 0, 0);
    transition: opacity 150ms, transform 1.5s;
  }

  .left .transition-wrap-exit {
    position: absolute;
    opacity: 1;
    //transform: translate3d(-100%, 0, 0);
  }

  .left .transition-wrap-exit-active {
    position: absolute;
    opacity: 0;
    //transform: scale(0.9);
    //transform: translate3d(-100%, 0, 0);
  }

  // right

  .right .transition-wrap-enter {
    position: absolute;
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .right .transition-wrap-enter-active {
    opacity: 1;
    transform: translate3d(-100%, 0, 0);
    transition: opacity 300ms, transform 1.5s;
  }

  .right .transition-wrap-exit {
    position: absolute;
    opacity: 1;
    transform: translate3d(100%, 0, 0);
  }

  .right .transition-wrap-exit-active {
    position: absolute;
    opacity: 0;
    transform: scale(0.9);
    transform: translate3d(100%, 0, 0);
  }

  > .section {
    width: 100%;
    height: 100%;
  }

  .page-wrap {
    display: block;
    overflow: hidden;
    position: relative;
    z-index: 5;
    width: 100%;
    height: 100%;
  }

  > .header {
    position: fixed;
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 48px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    z-index: 11;
    padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};

    > .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: ${(p) => (p.isApp ? `${p.isApp / 2}px` : "0px")};
      color: ${(p) => p.theme.color.black400};

      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    > .close {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }
`;
type Step =
  | "id"
  | "password"
  | "nickname"
  | "address"
  | "cert"
  | "cert_cancel"
  | "cert_name"
  | "cert_birth"
  | "cert_phone"
  | "referral"
  | "terms"
  | "complete"
  | "cert_used_pub"
  | "cert_experience"
  | "cert_route";

export interface UserData {
  id?: string;
  password?: string;
  nickname?: string;
  username?: string;
  phoneNumber?: string;
  birthYear?: string;
  birthMonth?: string;
  birthDate?: string;
  gender?: "MALE" | "FEMALE";
  certificated?: boolean;
  referral?: string;
  agreements?: boolean[];
  signupType?: string;
  accessToken?: string;
  areaProvinceId?: number;
  areaCityId?: number;
  role?: string;
}

interface SignupProps {
  snsData: LoginRouterState;
  onClose: () => void;
}

const Signup = ({ snsData, onClose }: SignupProps) => {
  const history = useHistory();
  const orientation = useScreenOrientation();
  const [step, setStep] = useState<Step>("id");
  const [userData, setUserData] = useState<UserData>({});
  const [done, setDone] = useState(false);
  const [showCertSkipSheet, setShowCertSkipSheet] = useState(false);
  const [showTermsSheet, setShowTermsSheet] = useState(false);
  const { sendMessageToNative } = useNativeApp();
  const setLoading = useSetRecoilState(loadingState);
  let isAlreadyDoReferral = false;
  const inset = useRecoilValue(insetState);
  const [certName, setCertName] = useState("");
  const [certBirthYear, setCertBirthYear] = useState("");
  const [certBirthMonth, setCertBirthMonth] = useState("");
  const [certBirthDate, setCertBirthDate] = useState("");
  const [certPhone, setCertPhone] = useState("");
  const [isOpenUseApp, setIsOpenUseApp] = useState(false);
  const [certUsedPub, setCertUsedPub] = useState<boolean | null>(null);
  const [certExperience, setCertExperience] = useState<number | null>(null);
  const [certRoute, setCertRoute] = useState<string | null>(null);
  const [certGender, setCertGender] = useState<string | null>(null);
  const { openDialog } = useDialog();

  const verifyId = async (id: string): Promise<boolean> => {
    try {
      const { code } = await authVerifiedTextId({ textId: id });
      return code === 200;
    } catch (e: any) {
      enqueueSnackbar(e.message, { variant: "error" });
      return false;
    }
  };

  useEffect(() => {
    // URL에서 store_redirect 파라미터 확인
    const params = new URLSearchParams(window.location.search);
    const shouldRedirect = params.get("store_redirect");

    if (shouldRedirect === "true" && !isApp) {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isIOS) {
        window.location.href = "https://apps.apple.com/app/6469495456";
      } else {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.runnersoft.runnerrunner";
      }
    }
  }, []);

  const goToApp = () => {
    if (!isApp) {
      const isKakao = /KAKAOTALK/i.test(navigator.userAgent);
      const redirectUrl =
        window.location.href +
        (window.location.search ? "&" : "?") +
        "store_redirect=true";
      // 앱 실행 시도
      if (isKakao) {
        window.location.href =
          "kakaotalk://web/openExternal?url=" + encodeURIComponent(redirectUrl);
      } else {
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (isIOS) {
          const link = document.createElement("a");
          link.href = redirectUrl;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.open(redirectUrl, "_blank");
          window.close();
        }
      }
      return;
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referral = urlParams.get("referral");

    if (!isApp && orientation !== "landscape" && referral) {
      setIsOpenUseApp(true);
    }
  }, []);

  const verifyNickname = async (nickname: string) => {
    try {
      const { verified } = await authVerifiedNickname({ nickname });
      if (!verified) {
        enqueueSnackbar("이미 사용중인 닉네임입니다.", { variant: "error" });
      }
      return verified;
    } catch (e: any) {
      enqueueSnackbar(e.message, { variant: "error" });
      return false;
    }
  };

  const verifyReferrer = async (nickname: string): Promise<boolean> => {
    try {
      const referrer = await authFindByNickname({ nickname });
      if (!referrer.validate) {
        enqueueSnackbar("본인인증이 되어 있지 않은 추천인입니다.", {
          variant: "error",
        });
        return false;
      }
      return true;
    } catch (e: any) {
      if (e.code === USER_NOT_FOUND) {
        enqueueSnackbar("존재하지 않는 추천인 입니다.", { variant: "error" });
      }
      return false;
    }
  };

  const certificateUser = () => {
    setShowCertSkipSheet(false);
    setLoading(true);
    certification()
      .then((res) => {
        setShowCertSkipSheet(false);

        if (res.existed) {
          enqueueSnackbar("이미 가입된 회원입니다.", { variant: "error" });
          setStep("nickname");
        } else {
          const newUserData: UserData = {
            ...userData,
            username: res.username,
            phoneNumber: res.phoneNumber,
            birthYear: res.birth[0],
            birthMonth: res.birth[1],
            birthDate: res.birth[2],
            gender: res.gender,
            certificated: true,
          };
          isAlreadyDoReferral = res.isAlreadyDoReferral;
          setUserData(newUserData);
          enqueueSnackbar("본인인증 되었습니다.", { variant: "success" });

          nextStep("cert", newUserData);
        }
      })
      .catch((e: any) => {
        if (e.message === "failed to init") {
          enqueueSnackbar("현재 본인인증을 할 수 없습니다", {
            variant: "error",
          });
        } else {
          enqueueSnackbar("본인인증에 실패했습니다: " + e.message, {
            variant: "error",
          });
        }
        setStep("nickname");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    //PC버전인경우, signup으로 랜딩
    if (orientation === "landscape") {
      onClose();
      history.push("/signup");
    }
  }, [orientation]);

  // SNS 정보를 이용한 회원가입 핸들링
  useEffect(() => {
    const userData = {
      id: snsData?.textId || "",
      password: "",
      signupType: snsData?.loginType,
      accessToken: snsData?.accessToken,
    };

    if (snsData.textId) {
      snsData.textId = snsData.textId.toLowerCase();
    }

    if (userData.signupType && userData.accessToken) {
      setUserData(userData);
      setStep("nickname");
    }
  }, [snsData]);

  const signUp = (userData: UserData) => {
    authSignUp({
      textId: userData.id!,
      password: userData.password!,
      nickname: userData.nickname!,
      username: certName !== "" ? certName : userData.username!,
      phoneNumber: certPhone !== "" ? certPhone : userData.phoneNumber!,
      birthYear: certBirthYear !== "" ? certBirthYear : userData.birthYear!,
      birthMonth: certBirthMonth !== "" ? certBirthMonth : userData.birthMonth!,
      birthDate: certBirthDate !== "" ? certBirthDate : userData.birthDate!,
      gender: certGender !== null ? certGender : userData.gender || null,
      expireType: "ONE_YEAR",
      isAgree1: userData.agreements![0],
      isAgree2: userData.agreements![1],
      isAgree3: userData.agreements![2],
      isAgree4: userData.agreements![3],
      isAgree5: userData.agreements![4],
      isAllAgree: userData.agreements!.find((x) => !x) === undefined,
      isValidate: certPhone !== "" ? false : !!userData.certificated,
      recommendNickname: userData.referral || "",
      signupType: userData.signupType || "",
      accessToken: userData.accessToken || "",
      areaProvinceId: userData?.areaProvinceId,
      areaCityId: userData?.areaCityId,
      role: userData?.role ?? "ROLE_USER",
      experience: certExperience,
      route: certRoute,
      usedPub: certUsedPub,
    })
      .then(async (res) => {
        if (process.env.REACT_APP_ENV === "production") {
          if (!isApp) {
            if (userData.referral) {
              Adjust.trackEvent({
                eventToken: "dm6m4f",
                callbackParams: [
                  { key: "user_id", value: "" + res.payload.id },
                  { key: "event_value", value: "" + userData.id },
                ],
              });
            } else {
              Adjust.trackEvent({
                eventToken: "f0hhdw",
                callbackParams: [
                  { key: "user_id", value: "" + res.payload.id },
                  { key: "event_value", value: "Signup" },
                ],
              });
            }
          } else {
            if (userData.referral) {
              sendMessageToNative("adjustEvent", "", {
                eventToken: "dm6m4f",
                eventName: "Regiester_recommend",
                data: userData.id!,
                callbackParams: {
                  user_id: "" + res.payload.id,
                  event_value: "" + userData.id,
                },
              });
            } else {
              sendMessageToNative("adjustEvent", "", {
                eventToken: "f0hhdw",
                eventName: "Signup",
                data: userData.id!,
                callbackParams: {
                  user_id: "" + res.payload.id,
                  event_value: "Signup",
                },
              });
            }
          }
        }
        setDone(true);
        if (userData.referral) {
          referralLogRegister({
            referralName: userData.referral,
            newUserName: userData.nickname!,
            textId: userData.id!,
          }).then(() => {
            enqueueSnackbar("추천인 등록이 완료되었습니다.", {
              variant: "success",
            });
          });
        }
      })
      .catch((e: any) => {
        if (e.statusCode === 400) {
          enqueueSnackbar("회원가입 실패: " + e.message, { variant: "error" });
          setTimeout(() => {
            setDone(false);
            window.location.reload();
          }, 800);
        } else {
          setDone(false);
        }
      });
  };

  const nextStep = async (current: Step, userData: UserData) => {
    if (current === "id") {
      setLoading(true);
      try {
        const verified = await verifyId(userData.id!);
        if (!verified) {
          setLoading(false);
          return;
        }
        setStep("password");
        setLoading(false);
      } catch (e: any) {
        setLoading(false);
      }
    } else if (current === "password") {
      setStep("nickname");
    } else if (current === "nickname") {
      setLoading(true);
      const verified = await verifyNickname(userData.nickname!);
      if (!verified) {
        setLoading(false);
        return;
      }
      setStep("address");
      setLoading(false);
    } else if (current === "address") {
      setShowCertSkipSheet(true);
    } else if (current === "cert") {
      setShowCertSkipSheet(false);
      if (userData.certificated && !isAlreadyDoReferral) {
        setStep("referral");
      } else {
        if (isAlreadyDoReferral) {
          enqueueSnackbar("가입하신 번호로 이미 추천인 등록이 되어있습니다.", {
            variant: "error",
          });
        }
        setStep("cert_used_pub");
      }
    } else if (current === "cert_cancel") {
      setShowCertSkipSheet(false);
      setStep("cert_name");
    } else if (current === "cert_name") {
      setStep("cert_birth");
    } else if (current === "cert_birth") {
      setStep("cert_phone");
    } else if (current === "cert_phone") {
      //setShowTermsSheet(true);
      //설문조사 시작
      setStep("cert_used_pub");
    } else if (current === "cert_used_pub") {
      setStep("cert_experience");
    } else if (current === "cert_experience") {
      if (certExperience === null) {
        return;
      }
      setStep("cert_route");
    } else if (current === "cert_route") {
      if (certRoute === null) {
        return;
      }
      setShowTermsSheet(true);
    } else if (current === "referral") {
      if (userData.referral) {
        const verified = await verifyReferrer(userData.referral!);
        if (!verified) {
          return;
        }
      }
      //설문조사 시작
      setStep("cert_used_pub");
      //setShowTermsSheet(true);
    } else if (current === "terms") {
      setShowTermsSheet(false);
      setStep("complete");
      signUp(userData);
    }

    setUserData({ ...userData });
  };

  const handleCloseSignUp = useCallback(() => {
    openDialog({
      text: "회원가입을 취소하시겠습니까?",
      confirm: true,
      type: "web",
      confirmText: "예",
      cancelText: "아니오",
      onConfirm: () => {
        window.location.href = "/login";
      },
    });
  }, [history, openDialog]);

  return orientation === "portrait" ? (
    <SignupWrapper isApp={inset}>
      <div className="header">
        {step !== "complete" && (
          <img
            className="close"
            src="/image-web/Icon/Close_gray.svg"
            onClick={handleCloseSignUp}
          />
        )}
        <div className="title">회원가입</div>
      </div>
      <div className="wrap">
        <TransitionGroup className={`transition-group left`}>
          <CSSTransition
            key={step}
            timeout={{
              enter: 150,
              exit: 150,
            }}
            classNames={"transition-wrap"}
          >
            <div className="route-section fade">
              {step === "id" && (
                <StepId
                  onNext={(data) => {
                    nextStep(step, {
                      ...userData,
                      id: data.id,
                    });
                  }}
                />
              )}
              {step === "password" && (
                <StepPassword
                  onNext={(data) => {
                    nextStep(step, {
                      ...userData,
                      password: data.password,
                    });
                  }}
                />
              )}
              {step === "nickname" && (
                <StepNickname
                  onNext={(data) => {
                    nextStep(step, {
                      ...userData,
                      nickname: data.nickname,
                    });
                  }}
                />
              )}
              {step === "referral" && (
                <StepReferral
                  onNext={(data) => {
                    nextStep(step, {
                      ...userData,
                      referral: data.referral,
                    });
                  }}
                />
              )}
              {step === "address" && (
                <StepAddress
                  onNext={(data) => {
                    nextStep(step, {
                      ...userData,
                      areaProvinceId: data.areaProvinceId,
                      areaCityId: data.areaCityId,
                      role: data.role,
                    });
                  }}
                />
              )}
              {step === "cert_name" && (
                <StepCertName
                  certName={certName}
                  setCertName={setCertName}
                  onNext={() => nextStep(step, userData)}
                />
              )}
              {step === "cert_birth" && (
                <StepCertBirth
                  certBirthYear={certBirthYear}
                  setCertBirthYear={setCertBirthYear}
                  certBirthMonth={certBirthMonth}
                  setCertBirthMonth={setCertBirthMonth}
                  certBirthDate={certBirthDate}
                  setCertBirthDate={setCertBirthDate}
                  onNext={() => nextStep(step, userData)}
                  setCertGender={setCertGender}
                  certGender={certGender}
                />
              )}
              {step === "cert_phone" && (
                <StepCertPhone
                  certPhone={certPhone}
                  setCertPhone={setCertPhone}
                  onNext={() => nextStep(step, userData)}
                />
              )}

              {step === "cert_used_pub" && (
                <StepCertUsedPub
                  certUsedPub={certUsedPub}
                  setCertUsedPub={setCertUsedPub}
                  onNext={() => nextStep(step, userData)}
                />
              )}
              {step === "cert_experience" && (
                <StepCertExperience
                  certExperience={certExperience}
                  setCertExperience={setCertExperience}
                  onNext={() => nextStep(step, userData)}
                />
              )}
              {step === "cert_route" && (
                <StepCertRoute
                  certRoute={certRoute}
                  setCertRoute={setCertRoute}
                  onNext={() => nextStep(step, userData)}
                />
              )}
              {step === "complete" && (
                <StepComplete
                  done={done}
                  onNext={() => {
                    window.location.href = "/login";
                  }}
                />
              )}
            </div>
          </CSSTransition>
        </TransitionGroup>
      </div>
      <CertAskSheet
        show={showCertSkipSheet}
        onSkip={() => nextStep("cert_cancel", userData)}
        onContinue={certificateUser}
      />
      <TermsSheet
        show={showTermsSheet}
        onContinue={(arr) =>
          nextStep("terms", {
            ...userData,
            agreements: arr,
          })
        }
        onClose={() => setShowTermsSheet(false)}
        onError={() => {
          const termSheet = document.getElementById("terms-sheet");
          if (termSheet) {
            //Zindex를 낮춰서 snackbar가 보여지게
            termSheet.style.zIndex = "99";
            setTimeout(() => {
              enqueueSnackbar("필수약관에 모두 동의해주세요", {
                variant: "error",
              });
            }, 200);
          }
        }}
      />
      {isOpenUseApp && (
        <OpenApp
          openApp={() => goToApp()}
          onClose={() => setIsOpenUseApp(false)}
        />
      )}
    </SignupWrapper>
  ) : (
    <></>
  );
};

export default Signup;
